/**
 * Use this file to all in scripts and functions you would like to have globally or on specific
 * pages. You will use this to extend your theme instead of adding code to the core framework files.
 */

function _defineProperties(target, props) {
	for (var i = 0; i < props.length; i++) {
		var descriptor = props[i];
		descriptor.enumerable = descriptor.enumerable || false;
		descriptor.configurable = true;
		if ("value" in descriptor) descriptor.writable = true;
		Object.defineProperty(target, descriptor.key, descriptor);
	}
}

function _createClass(Constructor, protoProps, staticProps) {
	if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	if (staticProps) _defineProperties(Constructor, staticProps);
	return Constructor;
}

function _classCallCheck(instance, Constructor) {
	if (!(instance instanceof Constructor)) {
		throw new TypeError('Cannot call a class as a function');
	}
}

var themeFunctionality = {
	init: function () {
		themeFunctionality.pageID = document.body.id.toCamelCase();

		/**
		 * Create MediaQueryList using breakpoint name
		 * @param {string} breakpointName
		 * @return {MediaQueryList|null}
		 */
		(function() {
			var breakpointSizes = {
				small: 40,
				medium: 48,
				large: 60,
				widescreen: 90,
			};

			window.mediaQueryListFactory = function mediaQueryListFactory(breakpointName) {;
				if (!breakpointName || !window.matchMedia) {
					return null;
				}

				var breakpoint = breakpointSizes[breakpointName];
				var mediaQuery = '(min-width: ' + breakpoint + 'em)';
				return window.matchMedia(mediaQuery);
			};

			themeFunctionality.mediaQueryLists = {
				small: mediaQueryListFactory('small'),
				medium: mediaQueryListFactory('medium'),
				large: mediaQueryListFactory('large'),
				widescreen: mediaQueryListFactory('widescreen'),
			};
		})();

		/**
		 * Load and initialize the Fasten Header extension
		 */
		// $.loadScript(theme_path + 'extensions/fasten-header/fasten-header.min.js');
		var $sticky = $.hook("sticky-target");
		if ($sticky.length) {
			import('extensions/sticky/jquery.sticky-kit.min').then(function () {
				$sticky.each(function(i, sticky) {
					var options = $(sticky).data('options');
					var $this = $(sticky);

					switch(themeFunctionality.pageID) {
						case 'jsPROD': {
							var widescreenList = themeFunctionality.mediaQueryLists.widescreen;
							function onWidescreenMatch(event) {
								if (event.matches) {
									$this.stick_in_parent(options);
								} else {
									$this.trigger('sticky_kit:detach');
								}
							}

							onWidescreenMatch(widescreenList);
							widescreenList.addListener(onWidescreenMatch);

							break;
						}
						case 'js-CTGY_QUESTION_BUILDER': {
							$this.trigger('sticky_kit:detach');
							break;
						}

						default: {
							$(sticky).stick_in_parent(options);
						}
					}
				});
			});
		}

		// TODO add to bundle
		var $slick = $('[data-slick]');
		var $otherSlick = $.hook('x-product-layout-images__image-carousel')
			.add($.hook('x-product-layout-images__thumbnail-list'))
			.add($.hook('product-carousel'));

		if ($slick.length || $otherSlick.length) {
			themeFunctionality.slickLoading = true;
			import('extensions/slick/slick').then(function() {
				$(window).trigger('slickLoaded');

				if (!$slick.length) return;

				if (typeof document.documentElement.style.objectFit === 'undefined') {
					$('.testimonials-slide').each(function() {
						var $container = $(this).find('.image-wrap');
						var imgUrl = $container.find('img').data('lazy');

						if (imgUrl) {
							$container.css('backgroundImage', 'url(' + imgUrl + ')').addClass('compat-object-fit');
						}
					});
				}

				$slick.each(function(i, slider) {
					var $slider = $(slider);
					var config = $slider.data('slick');
					if ($slider.children().length <= config.slidesToShow) config.dots = false;
					if (config.responsive && config.responsive.length) {
						config.responsive = config.responsive.map(function(item) {
							if (item.settings.slidesToShow && $slider.children().length <= item.settings.slidesToShow) item.settings.dots = false;

							return item;
						});
					}

					$slider.slick(config);
				});
			});
		}

		/* Custom Close Button for Modal Windows */
		$('body').on('click', '.c-mini-modal__cclose', function(e){
			$('body').find('.c-mini-modal__close').trigger('click');
		});

		if ( $('body').hasClass('t-page-quickview') ) {
			console.log('quickview');
		} else {
			/**
			 * Load and initialize the Mini-Basket extension
			 */
			import('extensions/mini-basket--custom/mini-basket').then(function ({miniBasket}) {
				miniBasket.init();
			});
		}
	},
	sharedFunctions: {
		initVimeoPlayer: async function () {
			const Player = await import('@vimeo/player');;

			/**
			 * @param  {String} func Name of the callback function
			 * @param  {Object} minimodal Class instance of the mini modal
			 */
			return async function (func, minimodal) {
				const minimodalElement = minimodal.content.querySelector('.c-mini-modal__element');
				const minimodalVideoElement = minimodalElement.querySelector('.c-mini-modal__video');
				const mediaID = minimodal.current.getAttribute('data-media-id');

				if (mediaID.trim().length === 0) {
					return;
				}

				// Media player styling
				minimodalElement.classList.add('c-mini-modal__element--video');

				/*
				 * Create a new instance of a video player. We cannot use the same player instance as
				 * the mini-modal will remove all the content from the DOM tree. Creating multiple player
				 * instances does cause us to request `player.js` and `player.css` multiple times. The browser
				 * will cache these resources.
				*/
				const mediaPlayer = new Player.default(minimodalVideoElement, {
					height: minimodalElement.offsetHeight,
					id: mediaID,
					width: minimodalElement.offsetWidth
				});

				// Add media player styling and play video when the `iframe` is initialized
				await mediaPlayer.ready();
				mediaPlayer.element.classList.add('c-mini-modal__video');

				await mediaPlayer.setVolume(0.5);
				await mediaPlayer.play();
			}
		},
		createCookie: function(c, d, a) {
			if (a) {
				var b = new Date;
				b.setTime(b.getTime() + 864E5 * a);
				a = "; expires=" + b.toGMTString()
			} else a = "";
			document.cookie = c + "=" + d + a + "; path=/"
		},
		readCookie: function(b) {
			for (var b = b + "=", d = document.cookie.split(";"), c = 0; c < d.length; c++) {
				for (var a = d[c];
					" " == a.charAt(0);) a = a.substring(1, a.length);
				if (0 == a.indexOf(b)) return a.substring(b.length, a.length)
			}
			return null
		},
		eraseCookie: function(a) {
			createCookie(a, "", -1)
		},
		xToggleDrawer: function() {

			/**
			 * Drawer toggling
			 */
			// define helper vars
			var $handles = $.hook('x_toggle_handle');
			var $drawers = $.hook('x_toggle_drawer');

			// assign index number dynamically to handle ( corresponds to a matching drawer by index )
			var assignIndex = function(index, element) {

				var $element = $(element);
				$element.attr('data-index', index);

			};
			$handles.each(assignIndex);

			// bind events
			$handles.on('click', function() {

				var $handle = $(this);
				var index = $handle.data('index');

				var $handleText = $handle.find('[data-hook~="x_toggle_handle_text"]');
				var shownText = $handleText.data('shown');
				var hiddenText = $handleText.data('hidden');

				// get drawer by index
				var $drawer = $($drawers.get(index));

				// if drawer was found
				if ($drawer.length == 1) {

					// handle text set
					if (!$drawer.is(':visible')) {
						$handleText.text(shownText);
					} else {
						$handleText.text(hiddenText);
					}

					// toggle drawer display
					$drawer.toggle();

				}

			});

		},
		initProductModal: function(container) {

			if ($.fn.magnificPopup == undefined) {
				import('extensions/magnificpopup/jquery.magnific-popup').then(function() {
					themeFunctionality.sharedFunctions.initProductModal('x-product-layout-images__anchor');
				});
			} else {
				$.magnificPopup.instance.popupsCache = {};

				$.hook(container).magnificPopup({
					gallery: {
						enabled: true
					},
					type: 'image'
				});
			}

		},
		initMiniModals: function() {
			var targets = document.querySelectorAll('[data-mini-modal]');
			for (var i = 0; i < targets.length; i += 1) {
				var modal = minimodal(targets[i], {
					// options
					statusTimeout: 600,
					removeTimeout: 600,
					closeTimeout: 600
				});
				modal.init();
			}
		},
		productShareButtons: function() {

			function PopupCenter(url, title, w, h) {
				// Fixes dual-screen position                         Most browsers      Firefox
				var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
				var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

				var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
				var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

				var left = ((width / 2) - (w / 2)) + dualScreenLeft;
				var top = ((height / 2) - (h / 2)) + dualScreenTop;
				var newWindow = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

				// Puts focus on the newWindow
				if (window.focus) {
					newWindow.focus();
				}
			}

			$.hook('x-social-sharing--cell__link').on('click', function(e) {
				e.preventDefault();

				console.log('social - click');

				var $this = $(this);
				var social_media_type = $this.attr('data-social');
				var url = '';

				switch (social_media_type) {
					case 'facebook':
						url = $this.attr('href');
						url += '&u=' + $this.attr('data-u');
						PopupCenter(url, 'Share', 750, 650);
						break;
					case 'twitter':
						url = $this.attr('href');
						PopupCenter(url, 'Share', 500, 300);
						break;
					case 'pinterest':
						url = $this.attr('href');
						url += '?url=' + $this.attr('data-url');
						url += '&media=' + $this.attr('data-media');
						url += '&description=' + $this.attr('data-description');
						PopupCenter(url, 'Share', 750, 650);
						break;
				}

				return false;
			});

		},
		redeemCoupon: function() {
			var checkout_basket_summary_selector = '#checkout_basket_summary';
			$.hook('basket_coupon-form').on('submit', function(e) {

				e.preventDefault();
				var $form = $(this),
					$button = $form.find('.c-button');

				// Throttle Submits
				if ($button.prop('disabled')) return;
				$button.prop('disabled', true).data('orig-val', $button.val()).val('Processing...');
				$form.find('#messages').remove();

				// AJAX Redeem Coupon
				$.ajax({
						url: $form.prop('action'),
						type: $form.prop('method'),
						data: $form.serialize()
					})
					.done(function(response) {
						console.log(response);
						var $response = $(response),
							$checkout_basket_summary = $(checkout_basket_summary_selector),
							$response_messages = $response.find('#messages');

						$checkout_basket_summary.replaceWith($response.find(checkout_basket_summary_selector));

						if ($response_messages.find('.x-messages--error').length) {
							$form.append($response_messages);
						}
					})
					.always(function() {
						$button.val($button.data('orig-val')).prop('disabled', false);
					});
			});
		},
		redeemGiftCertificate: function() {
			var checkout_basket_summary_selector = '#checkout_basket_summary';
			$.hook('gift_certificate-form').on('submit', function(e) {

				e.preventDefault();
				var $form = $(this),
					$button = $form.find('.c-button');

				// Throttle Submits
				if ($button.prop('disabled')) return;
				$button.prop('disabled', true).data('orig-val', $button.val()).val('Processing...');
				$form.find('#messages').remove();

				// AJAX Redeem Coupon
				$.ajax({
						url: $form.prop('action'),
						type: $form.prop('method'),
						data: $form.serialize()
					})
					.done(function(response) {
						console.log(response);
					})
					.always(function() {
						$button.val($button.data('orig-val')).prop('disabled', false);
					});
			});
		},
		xVariantKitPriceChange: function(product_data) {

			$.ajax({
					url: mivaJS.Miva_AJAX_URL,
					data: {
						Verb: 'Get_Variant_Kit_Price_SOP',
						Variant_ID: product_data.variant_id,
						Product_Code: product_data.product_code
					}
				})
				.done(function(response) {

					if (response && response.success) {

						$.hook('kit-price').text(response.data.kitPrice);

					} else {

						$.hook('kit-price').text(response.message);

					}

				});

		}
	},
	productFunctions: {
		initializeSlickSlider: function(container, options) {
			if (container.hasClass('slick-initialized')) {
				container.slick('unslick');
			}

			if ($.fn.slick == undefined) {
				import('extensions/slick/slick').then(function() {
					container.slick(options);
				});
			} else {
				container.slick(options);
			}
		}
	},
	jsSFNT: function() {},
	jsCTGY: function(pageID) {
	},
	jsCTGY_DESIGNER: function () {
		this.jsCTGY_TOP_DESIGNER();
	},
	jsCTGY_TOP_DESIGNER: async function () {
		const mivaJS = window.mivaJS || {};

		// Mini Modal open callback function
		mivaJS.loadVimeoPlayer = await this.sharedFunctions.initVimeoPlayer();
	},
	jsCTGY_TOP: function() {
		// Swiper Slider
		$.hook('shop-by-size').on('click', function(e) {
			$.hook('x-flex-slider__visible').each(function(i, elem) {
				if (elem.slick) {
					elem.slick.orientationChange();
					elem.slick.slickUnfilter();
				}
			});
		});

		// Show More Toggles
		$.hook('x-subcat-list__loadsizes').on('click', function(event){
			$('.c-ctgy--tabs__content___hidden').toggleClass('u-hidden');

			$(event.currentTarget).toggleClass('active');

			if ( $(event.currentTarget).find('.c-button--seemore---label').text().trim() == 'See More Sizes') {
				$(event.currentTarget).find('.c-button--seemore---label').text('See Less Sizes');
			} else {
				$(event.currentTarget).find('.c-button--seemore---label').text('See More Sizes');
			}

			$.hook('x-flex-slider__invisible').each(function(i, elem) {
				if (elem.slick) {
					elem.slick.orientationChange();
					elem.slick.slickUnfilter();
				}
			});
		});
	},
	jsCTGY_VISUAL: function() {
	},
	jsCTGY_MODEL: function() {
	},
	jsCTGY_QSTN: function() {
	},
	jsCTGY_SIZE: function() {
	},
	jsPROD: function() {

		var $windowWidth = $(window).width(),
			thumbnailLength = 5;

		/**
		 * Buy Together
		 */
		if ($('.x-buytogether-wrapper').length) {
			import('extensions/buytogether/buytogether');
		}

		$('body').on('change', '.x-buytogether-list__input', function() {
			var totals = 0,
				total_qty = 0;

			$('.x-buytogether-list__input').each(function() {
				var checked = $(this).is(':checked');
				console.log('Checked', checked);
				if (checked) {
					var price = $(this).data('prodprice');
					totals += parseFloat(price);
					total_qty++;

					console.log(parseFloat(price));
				}
			});

			$('body').find('.x-buytogether-list__total').text('$' + totals.toFixed(2));
			$('body').find('.x-buytogether-list__qty').text(total_qty);

			console.log('total', totals, 'qty', total_qty);
		});

		/**
		 * Load and initialize the Quantify extension
		 */
		import('extensions/quantify/quantify');

		/**
		 * Load and initialize the Tabs extension
		 */
		import('extensions/tabs/tabs');

		/**
		 * Load and initialize magnificPopup
		 */
		import('extensions/magnificpopup/jquery.magnific-popup').then(function() {
			themeFunctionality.sharedFunctions.initProductModal('x-product-layout-images__anchor');
		});

		/**
		 * Load and initialize product page carousels
		 */
		$(window).on('resize', function () {
			if ( $windowWidth < 960 ) {
				thumbnailLength = 3
			}
		});

		var $mainContainer = $.hook('x-product-layout-images__image-carousel'),
			mainOptions = {
				lazyLoad: 'ondemand',
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: $('.x-product-layout-images__prev'),
				nextArrow: $('.x-product-layout-images__next'),
				infinite: true,
				arrows: true
			};

		var $thumbnailContainer = $.hook('x-product-layout-images__thumbnail-list'),
			thumbnailOptions = {
				lazyLoad: 'ondemand',
				slidesToShow: 5,
				slidesToScroll: 1,
				infinite: true,
				arrows: false,
				asNavFor: '.x-product-layout-images__image-carousel',
				responsive: [
					{
						breakpoint: 768,
						settings: {
							slidesToShow: 3,
							infinite: true
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 3,
							infinite: true
						}
					}
				]
			};

		var $carouselContainer = $.hook('product-carousel'),
			carouselOptions = {
				lazyLoad: 'ondemand',
				slidesToShow: 4,
				slidesToScroll: 1,
				infinite: true,
				arrows: true,
				prevArrow:'<button type="button" class="x-flex-slider--prev slick-prev t-icon-arrow_carousel_prev" aria-label="Previous" role="button"></button>',
				nextArrow: '<button type="button" class="x-flex-slider--next slick-next t-icon-arrow_carousel_next" aria-label="Next" role="button"></button>',
				responsive: [
					{
						breakpoint: 960,
						settings: {
							centerMode: true,
							centerPadding: '40px',
							slidesToShow: 2
						}
					},
					{
						breakpoint: 480,
						settings: {
							centerMode: true,
							centerPadding: '20px',
							slidesToShow: 1
						}
					}
				]
			}

		themeFunctionality.productFunctions.initializeSlickSlider($carouselContainer, carouselOptions);

		if ( $('#thumbnails > li').length > thumbnailLength || $('#thumbnails > div').length > thumbnailLength ) {
			themeFunctionality.productFunctions.initializeSlickSlider($thumbnailContainer, thumbnailOptions);
		} else {
			// Give the slick-initalize class to reveal list
			$.hook('x-product-layout-images__thumbnail-list').addClass('active');
		}

		$.hook('x-product-layout-images__thumbnail-image').on('click', function(e){
			var slide_index = $(this).attr('data-slick-index');
			$.hook('x-product-layout-images__image-carousel').slick('slickGoTo', slide_index);
		});

		themeFunctionality.productFunctions.initializeSlickSlider($mainContainer,mainOptions);

		$.hook('x-product-layout-images__image-carousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
			var prod_thumbs = $.hook('x-product-layout-images__thumbnail-list').hasClass('slick-initialized');

			if (prod_thumbs) {
				console.log('goto', currentSlide);
				$.hook('x-product-layout-images__thumbnail-list').slick('slickGoTo', currentSlide);
			} else {
				$.hook('x-product-layout-images__thumbnail-list').find('.x-product-layout-images__thumbnail-image').removeClass('slick-current');
				$.hook('x-product-layout-images__thumbnail-list').find('.x-product-layout-images__thumbnail-image').eq(currentSlide).addClass('slick-current');
			}

		});

		ImageMachine.prototype.oninitialize = function(data) {
			var self = this;

			if (data) {
				if (data[0] && data[0].image_data[1]) {
					var img = new Image();
					img.onload = function() {

						$('.x-product-layout-images__image-carousel.slick-initialized').slick('unslick');
						$('.x-product-layout-images__image-carousel').removeClass('slick-initialized').html('');

						$('.x-product-layout-images__thumbnail-list.slick-initialized').slick('unslick');
						$('.x-product-layout-images__thumbnail-list').removeClass('slick-initialized').html('');

						self.Initialize(data);
						themeFunctionality.productFunctions.initializeSlickSlider($thumbnailContainer, thumbnailOptions);
						themeFunctionality.productFunctions.initializeSlickSlider($mainContainer, mainOptions);
						themeFunctionality.sharedFunctions.initProductModal('x-product-layout-images__anchor');
						//themeFunctionality.sharedFunctions.initMiniModals();
					}
					img.src = data[0].image_data[1];
				} else {

					$('.x-product-layout-images__image-carousel.slick-initialized').slick('unslick');
					$('.x-product-layout-images__image-carousel').removeClass('slick-initialized').html('');

					$('.x-product-layout-images__thumbnail-list.slick-initialized').slick('unslick');
					$('.x-product-layout-images__thumbnail-list').removeClass('slick-initialized').html('');

					self.Initialize(data);
					themeFunctionality.productFunctions.initializeSlickSlider($thumbnailContainer, thumbnailOptions);
					themeFunctionality.productFunctions.initializeSlickSlider($mainContainer, mainOptions);
					themeFunctionality.sharedFunctions.initProductModal('x-product-layout-images__anchor');
				}
			}
		}

		if ( $(window).width() < 960 ) {
			$('.x-component--deck__wrap').removeClass('o-layout u-grids-2--m u-grids-3--w').addClass('x-flex-slider');
			$('.x-component--article__item, .x-component--video__item').removeClass('o-layout__item');
		}

		$('input[name="flex-tab"]').on('change', function(e){
			var $thisId = $(this).attr('id');
			if ( $(window).width() < 960 && $thisId === 'tab-resources' ) {
				$('.x-component--deck__wrap').slick({
					slidesToShow: 1.5,
					slidesToScroll: 1,
					infinite: false,
					arrows: false,
					responsive: [
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2.5
							}
						},
						{
							breakpoint: 480,
							settings: {
								slidesToShow: 1
							}
						}
					]
				});
			}
		});

		/**
		 * Load and initialize the qna extension
		 */
		import('extensions/qna/qna');

		/**
		 * Social Share
		 */
		themeFunctionality.sharedFunctions.productShareButtons();

		$.hook('toggle-options').on('click', function(e){
			$('.x-product-layout-purchase__attribute-hidden').toggleClass('u-hidden');

			$(this).toggleClass('active');

			if ( $(this).find('.c-button--text').text() === 'See More Choices' ) {
				$(this).find('.c-button--text').text('See Less Choices');
			} else {
				$(this).find('.c-button--text').text('See More Choices');
			}
		});

		/**
		 * "kitprice" Customer Login Kit Price on Variant Change display
		 */
		if (mivaJS.Customer_Login == 'kitprice') {

			MivaEvents.SubscribeToEvent('variant_changed', function(product_data) {

				themeFunctionality.sharedFunctions.xVariantKitPriceChange(product_data);

			});

			themeFunctionality.sharedFunctions.xVariantKitPriceChange({
				product_code: mivaJS.Product_Code,
				variant_id: mivaJS.Default_Variant_ID
			});

		}

		// Affirm Helper Functions - Start
		function setObserverOnAffirm() {
			// Target
			var targetNode = document.getElementById("price-value");

			if (targetNode === null) return;

			// Set callback and return instance
			var observer = new MutationObserver(observerOnAffirmCallback);

			// Set Observer
			observer.observe(targetNode, {
				characterData: true, //Firefox, IE
				subtree: true, //Firefox, IE
				childList: true // Chrome
			});
		}

		// Only run depending on what type
		/**
		 * @param  {Mutation Record<Array>} mutationList
		 */
		function observerOnAffirmCallback(mutationList) {
			// Return target
			var targetNode = mutationList[0].target;

			// Only have one observer and one type execute function
			updateAffirmPricingOnChange(targetNode);
		}

		/**
		 * @param  {DOM Node} price_node
		 */
		function updateAffirmPricingOnChange(price_node) {
			// Default
			var productPriceContainer = price_node || document.getElementById('price-value');
			var affirmContainer = document.querySelector('#affirm-container > .affirm-as-low-as');
			var productPrice = '000';

			if (!affirmContainer) {
				return;
			}

			// Ensure we have our elements and the correct attribute
			if (!affirmContainer.dataset.hasOwnProperty('amount') || productPriceContainer === null) return;

			// Return price
			productPrice = productPriceContainer.textContent.replace(/[$,\.]/g, '');

			// Set data attribute
			affirmContainer.dataset.amount = productPrice;

			// Refresh affirm UI
			affirm.ui.refresh();
		}
		// Affirm Helper Functions - End

		// On Load
		setObserverOnAffirm();

	},
	jsPLST: function() {
	},
	jsSRCH: function() {

	},
	jsBASK: function() {
		themeFunctionality.sharedFunctions.xToggleDrawer();

		/**
		 * Load and initialize the shipping estimate extension
		 */
		import('extensions/shipping-estimate/shipping-estimate');

		/**
		 * Load and initialize the Quantify extension
		 */
		import('extensions/quantify/quantify');

		/**
		 * Load and initialize the Manage Quotes extension
		 */
		import('extensions/request-quotes/request_quote');

		$.hook('x-basket-kit__toggle').on('click', function(e) {
			$(this).parents('.c-table-responsive__cell').find('.x-basket-kit').toggleClass('u-hidden');
		});

		$('body').on('change', '.c-form-input__group', function() {
			var $current_selection = $(this).val().indexOf('yes'),
				toggle_element = $(this).parents('.c-form-list__item').next('.x-quotes-form__row___toggle').length;

			if ( $current_selection > -1 && toggle_element > 0) {
				$(this).parents('.c-form-list__item').next('.x-quotes-form__row___toggle').removeClass('u-hidden');
			} else if ( $current_selection == -1 && toggle_element > 0 ) {
				$(this).parents('.c-form-list__item').next('.x-quotes-form__row___toggle').addClass('u-hidden');
				$(this).parents('.c-form-list__item').next('.x-quotes-form__row___toggle').find('input').val('');
			}
		});
	},
	jsORDL: function() {
	},
	jsORDS: function() {
		themeFunctionality.sharedFunctions.xToggleDrawer();
	},
	jsOCST: function() {

		themeFunctionality.sharedFunctions.xToggleDrawer();
		themeFunctionality.sharedFunctions.redeemCoupon();
	},
	jsOSEL: function() {
		import('extensions/basketfields/basketfields');
		themeFunctionality.sharedFunctions.xToggleDrawer();

		themeFunctionality.sharedFunctions.redeemCoupon();

		// Affirm Embed - Start
		var _affirm_config = {
			public_api_key: "VRM432K9OA5UUV84",
			/* Affirm Public API Key */
			script: "https://cdn1.affirm.com/js/v2/affirm.js",
			session_id: "sID"
		};

		(function(l, g, m, e, a, f, b) {
			var d, c = l[m] || {},
				h = document.createElement(f),
				n = document.getElementsByTagName(f)[0],
				k = function(a, b, c) {
					return function() {
						a[b]._.push([c, arguments])
					}
				};
			c[e] = k(c, e, "set");
			d = c[e];
			c[a] = {};
			c[a]._ = [];
			d._ = [];
			c[a][b] = k(c, a, b);
			a = 0;
			for (b = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < b.length; a++) d[b[a]] = k(c, e, b[a]);
			a = 0;
			for (b = ["get", "token", "url", "items"]; a < b.length; a++) d[b[a]] = function() {};
			h.async = !0;
			h.src = g[f];
			n.parentNode.insertBefore(h, n);
			delete g[f];
			d(g);
			l[m] = c
		})(window, _affirm_config, "affirm", "checkout", "ui", "script", "ready");
		// Affirm Embed - End
	},
	jsOPAY: function() {
		themeFunctionality.sharedFunctions.xToggleDrawer();
		themeFunctionality.sharedFunctions.redeemCoupon();
		//themeFunctionality.sharedFunctions.redeemGiftCertificate();
	},
	jsINVC: function() {
		themeFunctionality.sharedFunctions.xToggleDrawer();
	}
};

export {
	themeFunctionality
};